import { Role } from "@cryptors/api-client";
import DashboardIcon from "@mui/icons-material/Dashboard";
import {
  GlobalStyles,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { RefineThemedLayoutSiderProps, ThemedSider } from "@refinedev/mui";
import { Link, useLocation } from "react-router-dom";

import { getCurrentRole } from "@/providers/authProvider";

import { ClientCryptorGallery } from "./ClientCryptorGallery";

const expandedTitleSelector = [
  '.MuiDrawer-paper > .MuiPaper-root:has([data-branding-size="expanded"])',
  '.MuiDrawer-paper > div > div:has([data-branding-size="expanded"])',
].join(",");

const collapsedTitleSelector = [
  '.MuiDrawer-paper > .MuiPaper-root:has([data-branding-size="collapsed"])',
  '.MuiDrawer-paper > div > div:has([data-branding-size="collapsed"])',
].join(",");

const ClientDashboardItem = ({ collapsed }: { collapsed: boolean }) => {
  const { pathname } = useLocation();
  const selected = pathname === "/dashboard";

  return (
    <Tooltip
      title="Dashboard"
      placement="right"
      disableHoverListener={!collapsed}
      arrow
    >
      <ListItemButton
        component={Link}
        to="/dashboard"
        selected={selected}
        sx={{
          px: 2,
          py: 1,
          justifyContent: "center",
          color: selected ? "primary.main" : "text.primary",
        }}
      >
        <ListItemIcon
          sx={{
            justifyContent: "center",
            minWidth: 24,
            mr: collapsed ? 0 : 1.5,
            color: "currentColor",
          }}
        >
          <DashboardIcon />
        </ListItemIcon>
        {!collapsed && (
          <ListItemText
            primary="Dashboard"
            primaryTypographyProps={{ noWrap: true, fontSize: 14 }}
          />
        )}
      </ListItemButton>
    </Tooltip>
  );
};

export const Sider: React.FC<RefineThemedLayoutSiderProps> = (props) => {
  const isClient = getCurrentRole() === Role.CLIENT;

  return (
    <>
      <GlobalStyles
        styles={{
          [expandedTitleSelector]: {
            height: "144px",
            transition: "height 200ms ease",
          },
          [collapsedTitleSelector]: {
            height: "112px",
            transition: "height 200ms ease",
          },
        }}
      />
      <ThemedSider
        {...props}
        render={
          isClient
            ? ({ items, logout, collapsed }) => (
                <>
                  <ClientDashboardItem collapsed={collapsed} />
                  {items}
                  {logout}
                  <ClientCryptorGallery collapsed={collapsed} />
                </>
              )
            : props.render
        }
      />
    </>
  );
};
